<template>
    <hc-dialog
        width="480px"
        append-to-body
        title="修改演示数据"
        :visible.sync="visible"
        destroy-on-close
        :close-on-click-modal="false"
        custom-class="edit-mock-dialog"
        :before-close="beforeClose"
    >
        <hc-form label-width="102px" label-position="left">
            <hc-form-item>
                <span
                    slot="label"
                    style="display: inline-flex;align-items: center;"
                >模板下载
                    <svg-icon
                        name="common.question"
                        style="color:#666666;font-size:16px;margin-left: 2px;cursor:pointer;"
                        @click="toTemplateDoc"
                    />
                </span>
                <span class="downfile" @click="getTemplate">
                    演示数据模板.xls
                </span>
            </hc-form-item>
            <hc-form-item label="演示数据" required>
                <div class="upload-file">
                    <hc-upload
                        ref="editMockUpload"
                        name="mockObjectFile"
                        :auto-upload="false"
                        :action="`/api_v3/studio/mock/object/${objectId}/data-refresh`"
                        accept=".xls, .xlsx"
                        class="uploader"
                        :limit="1"
                        :on-error="uploadError"
                        :on-success="uploadScuess"
                        :on-change="uploadChange"
                        :on-remove="uploadRemove"
                    >
                        <hc-button :disabled="hasFile">
                            <svg-icon name="common.upload" />
                            上传
                        </hc-button>
                        <div v-if="hasFile" class="mask" @click.stop />
                        <span slot="tip" class="upload-tip">支持扩展名：.xls\xlsx</span>
                    </hc-upload>
                </div>
            </hc-form-item>
        </hc-form>
        <div slot="footer">
            <hc-button @click="beforeClose">
                取消
            </hc-button>
            <hc-button type="primary" :loading="loading" :disabled="!hasFile" @click="upload">
                确定
            </hc-button>
        </div>
    </hc-dialog>
</template>

<script>
import UploadMixin from './upload-mixin'

export default {
    name: 'EditMockData',
    mixins: [UploadMixin],
    props: {
        objectId: String,
        visible: Boolean,
    },
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        getTemplate() {
            const { origin } = location

            window.open(`${origin}/api_v3/studio/mock/object/data-template?objectId=${this.objectId}`)
        },
        reset() {
            this.loading = false
            this.hasFile = false
        },
        uploadError(err) {
            this.reset()
            const { error } = JSON.parse(err?.message || '{"error":"上传失败"}')
            this.$message.error(error)
        },
        uploadScuess() {
            this.reset()
            this.$message.success('修改成功')
            this.$emit('close')
        },
        upload() {
            this.loading = true
            this.$refs.editMockUpload.submit()
        },
        toTemplateDoc() {
            window.open('https://open.mingyuanyun.com/knowledge/mpaas/2015c638-d5d8-ed11-b4d3-9b0e7cef06ab')
        },
        beforeClose() {
            this.reset()
            this.$emit('close')
        },
    },
}
</script>
<style lang="less" scoped>
.edit-mock-dialog {
    .downfile {
        cursor: pointer;
        color: #266EFF;
    }
    .upload-file {
        /deep/ .hc-upload-list__item {
            margin-top: 0;
        }
        /deep/ .hc-upload {
            height: 34px;
            position: relative;
            .mask {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                cursor: not-allowed;
                background: rgba(238,238,238,0.6);
            }
        }
        .hc-button {
            /deep/ span {
                display: flex;
                color: #666;
                align-items: center;
            }
            .svg-icon {
                color: #666;
                font-size: 16px;
                margin-right: 4px;
            }
            &:hover,
            &:focus {
                /deep/ span,
                .svg-icon {
                    color: #266EFF;
                }
            }
        }
        .upload-tip {
            color: #999;
            font-size: 13px;
            margin-left: 8px;
            line-height: 22px;
            display: inline-block;
        }
    }
}

</style>
